import { render, staticRenderFns } from "./ESGscorePage.vue?vue&type=template&id=4fa6704c&scoped=true"
import script from "./ESGscorePage.vue?vue&type=script&lang=js"
export * from "./ESGscorePage.vue?vue&type=script&lang=js"
import style0 from "./ESGscorePage.vue?vue&type=style&index=0&id=4fa6704c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6704c",
  null
  
)

export default component.exports